import React, { useContext, useMemo, useState } from 'react';

import { TEACHER_ASSIGNMENT_CLASSROOM_INSIGHTS_URL } from 'config/urls';

import StudentProgressBox from 'pages/Teachers/ClassroomInsights/components/StudentProgressBox';
import StudentWorkDialog from 'pages/Teachers/ClassroomInsights/components/StudentWorkDialog';
import { trackMixpanelEvent } from 'utils/integrations/mixpanel';

import UserContext from 'components/UserContext';

import { MASTERY_LEVEL_TO_LABEL_MAPPER } from '../../constants';
import styles from './style.module.scss';

const StudentProgress = ({ students, onPublishSuccess }) => {
  const { user } = useContext(UserContext);
  const [activeStudentIndex, setActiveStudentIndex] = useState(null);

  const viewableStudents = useMemo(
    () =>
      students.filter((student) => student.student_tag_assignment_id !== null),
    [students]
  );

  const handleBoxClick = ({ student }) => {
    const index = viewableStudents.findIndex(
      (s) => s.student_tag_assignment_id === student.student_tag_assignment_id
    );
    if (index !== -1) setActiveStudentIndex(index);

    trackMixpanelEvent(user.id, 'Student tile clicked', {
      feature: 'live classroom insights',
      view: 'student progress',
      button: 'student tile',
      normalizedURL:
        process.env.REACT_APP_BASE_FRONTEND_URL +
        TEACHER_ASSIGNMENT_CLASSROOM_INSIGHTS_URL
    });
  };

  const currentStudent =
    activeStudentIndex !== null ? viewableStudents[activeStudentIndex] : null;

  return (
    <>
      <header>
        <div>
          <h3 className={styles.heading}>Students Progress</h3>
        </div>
      </header>
      <div className={styles.progressDashboard}>
        {students.map((student, index) => {
          return (
            <StudentProgressBox
              key={`studentprogress-${index}`}
              name={student.student_name}
              status={MASTERY_LEVEL_TO_LABEL_MAPPER[student.tag_description]}
              masteryLabel={student.tag_description}
              grade={student.student_work_score?.toLowerCase()}
              isPublished={['complete', 'revise'].includes(
                student.tracker_score_student_status
              )}
              onClick={() => handleBoxClick({ student })}
            />
          );
        })}

        {activeStudentIndex !== null && (
          <StudentWorkDialog
            currentStudent={currentStudent}
            onClose={() => {
              setActiveStudentIndex(null);
            }}
            onNext={() =>
              setActiveStudentIndex((prev) =>
                Math.min(prev + 1, viewableStudents.length - 1)
              )
            }
            onPrev={() =>
              setActiveStudentIndex((prev) => Math.max(prev - 1, 0))
            }
            onPublishSuccess={onPublishSuccess}
            disablePublish={['complete', 'revise'].includes(
              currentStudent.tracker_score_student_status
            )}
          />
        )}
      </div>
    </>
  );
};

export default StudentProgress;
